import * as Bootstrap from 'bootstrap';
import { cardSwipper } from "./card";
import { Gallery, GalleryShowPage } from "./gallery";
import { initMainNews } from "./main_news";
import { NewsPaginator } from "./news";
// import { initHeader, HeaderTransparentOnScroll, headerInit } from "./header"
import { MobileMenu } from "../../../components/web_components/mobile_menu/component";
import { Header } from "../../../components/web_components/header/component";
import { EventCalendar } from "./events";
import { lowVision } from "./low_vision";
// import { VirtualReception } from "./virtual_reception";
import { youtubeOmbed } from "./youtube";
import { externalLink } from "./external_link";
import { initYandexMetrica } from "./yandex_metrica";
import { enableSharedButtons } from "./share";
import { priemTimeline } from "./priem_timeline";
// import searchPlaceholder from "./js/web/search";

export function initWebsiteJs() {
  try {
    // initHeader();
    new Header();
  } catch (error) {
    console.log('initHeader error', error);
  }
  try {
    cardSwipper('tvsu-top-cards');
  } catch (error) {
    console.log('top-cards error');
  }
  try {
    cardSwipper('tvsu-bottom-cards');
  } catch (error) {
    console.log('bottom-cards error');
  }
  try {
    Gallery();
  } catch (error) {
    console.log('Gallery error');
  }
  try {
    GalleryShowPage();
  } catch (error) {
    console.log('GalleryShowPage error');
  }
  try {
    initMainNews();
  } catch (error) {
    console.log('initMainNews error');
  }
  try {
    EventCalendar();
  } catch (error) {
    console.log('EventCalendar error');
  }
  try {
    lowVision();
  } catch (error) {
    console.log('lowVision error');
  }

  try {
    new MobileMenu();
  } catch (error) {
    console.error('mobileMenu error', error);
  }
  try {
    new NewsPaginator();
  } catch (error) {
    console.error('initNews error', error);
  }
  // try {
  //   VirtualReception();
  // } catch (error) {
  //   console.log('VirtualReception error');
  // }
  try {
    youtubeOmbed();
  } catch (error) {
    console.log('youtubeOmbed error');
  }
  try {
    externalLink();
  } catch (error) {
    console.log('externalLink error');
  }
  try {
    initYandexMetrica();
  } catch (error) {
    console.log('yandex metrica error');
  }
  try {
    enableSharedButtons();
  } catch (error) {
    console.log('enableSharedButtons error', error);
  }
  try {
    priemTimeline();
  } catch (error) {
    console.log('priemTimeline error', error);
  }
}

